/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './MyLearningBFFChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService#getProgressItemsForMyLearningPage
 */

export const GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getProgressItemsForMyLearningPage',
  args: ['searchTerm', 'hasCertification', 'progressType', 'contentTypes', 'visibilityGroup', 'includePlaylistProgress', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProgressItemsForMyLearningPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});